import React, { useState } from 'react';
import axios from 'axios';
import FormularioDesconto from './FormularioDesconto';

export default function AdicionarDesconto(props) {
    const token = localStorage.getItem('token');

    const [discountCode, setDiscountCode] = useState('');
    const [valorDesconto, setValorDesconto] = useState('');
    const [duracaoMeses, setDuracaoMeses] = useState('');
    const [salvando, setSalvando] = useState(false);

    const handleClose = () => {
        setDuracaoMeses('');
        setValorDesconto('');
        setDiscountCode('');
        props.setAdicionarDesconto(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            setSalvando(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/adicionarDesconto`, {
                discountCode,
                valorDesconto,
                duracaoMeses
            }, {
                headers: {
                    Authorization: token
                }
            });
            setValorDesconto('');
            setDiscountCode('');
            handleClose();
        } catch (error) {
            console.error("Erro ao adicionar desconto:", error);
        } finally {
            setSalvando(false);
        }
    };

    return (
        <FormularioDesconto
            aberto={props.adicionarDesconto}
            titulo="Adicionar desconto"
            descricao="Crie um código promocional para novas assinaturas."
            textoBotao="Adicionar desconto"
            salvando={salvando}
            onClose={handleClose}
            onSubmit={handleSubmit}
            discountCode={discountCode}
            setDiscountCode={setDiscountCode}
            valorDesconto={valorDesconto}
            setValorDesconto={setValorDesconto}
            duracaoMeses={duracaoMeses}
            setDuracaoMeses={setDuracaoMeses}
        />
    );
}
